import React from 'react'
import { connect } from 'react-redux'
import { func, number, string } from 'prop-types'
import { useTranslation } from 'react-i18next'

import { productDataType } from 'models/propTypes'
import { ART_ITEM } from 'constants/renderItemTypes'
import * as modes from 'models/ui/constants'
import { getSelectedFurnitureData } from 'models/furniture/selectors'
import { getSelectedCompositionId } from 'models/compositions/selectors'
import { setDesignSidepanelMode } from 'models/ui/actions'
import { getDesignSidepanelMode } from 'models/ui/selectors'
import { clickPlaceRenderItem } from 'models/compositions/actions'
import ProductDetailsView from 'components/designSidepanel/ProductDetailsView'
import { trackShowDetails as trackShowDetailsAction } from 'models/tracking/actions'
import { addToBag as addToBagAction } from 'models/bag/actions'
import { getProductTrackingInfo } from 'models/tracking/utils'

const ProductDetailsViewContainer = ({
    setMode,
    productData,
    compositionId,
    placeRenderItem,
    addToBag,
    trackShowDetails,
    mode,
}) => {
    const { t } = useTranslation()

    const { localItemNumber, region, renderType, name, id, stacks, hidden, categories, subCategories } = productData

    const isArtItem = renderType === ART_ITEM
    const trackingInfo = getProductTrackingInfo(productData)

    let renderData
    if (isArtItem) {
        renderData = {
            matteId: 1,
            frameId: 1,
            sizeId: 1,
            colorId: 1,
            customHeight: null,
        }
    } else {
        renderData = {
            heading: 0,
            stacks,
            hidden,
        }
    }

    const addToRoom = () => {
        placeRenderItem(
            compositionId,
            id,
            {
                renderType,
                ...renderData,
            },
            trackingInfo,
        )
    }

    const onBackClick = () => {
        if (mode === modes.DESIGN_SIDEPANEL_MODE_FAVORITES_DETAILS) {
            setMode(modes.DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE)
        } else {
            setMode(modes.DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE)
        }
    }

    const getNavigationText = () => {
        if (mode === modes.DESIGN_SIDEPANEL_MODE_FAVORITES_DETAILS) {
            return t('design.favorites')
        }

        return `${categories[0]} / ${subCategories[0]}`
    }

    return (
        <ProductDetailsView
            furnitureData={productData}
            addToRoom={addToRoom}
            addToBag={() => addToBag(localItemNumber, region, name, trackingInfo)}
            trackShowDetails={() => trackShowDetails(trackingInfo)}
            onBackClick={onBackClick}
            navigationText={getNavigationText()}
        />
    )
}

ProductDetailsViewContainer.propTypes = {
    setMode: func.isRequired,
    productData: productDataType.isRequired,
    compositionId: number.isRequired,
    placeRenderItem: func.isRequired,
    addToBag: func.isRequired,
    trackShowDetails: func.isRequired,
    mode: string.isRequired,
}

const mapStateToProps = (state) => ({
    productData: getSelectedFurnitureData(state),
    compositionId: getSelectedCompositionId(state),
    mode: getDesignSidepanelMode(state),
})

const mapDispatchToProps = {
    setMode: setDesignSidepanelMode,
    placeRenderItem: clickPlaceRenderItem,
    addToBag: addToBagAction,
    trackShowDetails: trackShowDetailsAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailsViewContainer)
